import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import update from 'react-addons-update';
import _ from 'underscore';
import xtend from 'xtend';

import Loader from '../../../../common/components/notifications/Loader';
import Technicians from '../../../../metadata/components/technicians/Technicians';
import MetadataFilter from '../../../../metadata/components/MetadataFilter';
import MetadataPaginationMixin from '../../../mixins/MetadataPaginationMixin';
import RestrictedComponent from '../../../../lib/components/form/RestrictedComponent';
import schema from '../../../../routes/permissions/schema';

var EventTechnicians = createReactClass({
    mixins: [
        MetadataPaginationMixin
    ],

    propTypes: {
        actions: pt.shape({
            editEvent: pt.func.isRequired
        }).isRequired,
        data: pt.array.isRequired
    },

    getInitialState: function () {
        return xtend({
            isTyping: false,
            term: '',
            edited: false,
            edits: []
        }, this.getDefaultPaginationState());
    },

    save: function () {
        // map names to ID
        var addThese = this.state.edits.map(function (techName) {
            return _(this.props.data).find(function (tech) {
                return tech.techName === techName;
            }).techID;
        }, this);

        this.props.actions.editEvent({
            technicians: addThese
        });
    },

    revert: function () {
        this.setState(this.getInitialState());
    },

    /*
        State Functions
     */
    termChanged: function (value) {
        this.setState({
            isTyping: false,
            term: value.toLowerCase()
        });
    },

    /*
        handles De-bouncing
     */
    handleTypingStarted: function () {
        this.setState({
            isTyping: true
        });
    },

    /*
     * transferState:
     * 	This injests the current state of the assigned technicians as makes them
     * 	the active state here so any incoming changes via events can be omitted
     * 	while the user stages changes to the assigned technician listing
     */
    transferState: function () {
        if (!this.state.edited) {
            this.setState(function (state, props) {
                return {
                    edited: true,
                    edits: props.event.technicians
                };
            });
        }
    },

    assignTechnicianToEvent: function (index) {
        this.transferState();

        this.setState(function (state, props) {
            var technician = props.data[index];
            return {
                edits: update(state.edits, {$push: [technician['techName']]})
            };
        });
    },

    remove: function (index) {
        this.transferState();

        var updates = [];
        updates = {$splice: [[index, 1]]};

        this.setState(function (state) {
            return {
                edits: update(state.edits, updates)
            };
        });
    },

    /*
        Helper Functions
     */
    getAssignedTechnicians: function () {
        var techs = this.state.edited ?
            this.state.edits :
            this.props.event.technicians
        ;

        return techs;
    },

    // @TODO: DRY (should be the tech component)
    showSchedule: function (id) {
        var url = '/manage/technicians/schedule?id=' + id;
        window.location = url;
    },

    /*
        Render Functions
     */
    render: function () {
        if (this.props.isResolving) return <Loader message="Fetching"/>;

        var listing;
        var paginatedData = [];


        if (this.state.isTyping) {
            listing = <Loader message='Filtering'/>;
        } else {

            paginatedData = this.getPaginatedData();

            listing = <Technicians
                technicians={paginatedData}
                term={this.state.term}
                mode="event"
                assigned={this.getAssignedTechnicians()}
                assignTechnicianToEvent={this.assignTechnicianToEvent}/>;
        }

        var paginationElement = this.renderPagination();

        return (
            <div>
                <div className="callout clearfix">
                    <div className="col-sm-8">
                        <MetadataFilter termChanged={this.termChanged} isTyping={this.handleTypingStarted}/>
                    </div>

                    <div className="col-sm-4 tab-actions">
                        <button className="btn btn-default" disabled={!this.state.edited} onClick={this.revert}><i className="fa fa-undo"/> Revert Changes</button>
                        <RestrictedComponent permissionCheck={schema.EVENT_TAB_TECHNICIANS.UPDATE}>
                            <button style={{}} className="btn btn-success" disabled={!this.state.edited} onClick={this.save}><i className="fa fa-save"/> Save Changes</button>
                        </RestrictedComponent>
                    </div>
                </div>

                <hr/>

                <div className="col-sm-6">
                    <label>Assigned Technicians</label>
                    <div className="clearfix">
                        {this.renderAssigned()}
                    </div>
                </div>

                <div className="col-sm-6">
                    <label>Available Technicians</label>

                    <div className="row">
                        {paginationElement}
                    </div>

                    <hr/>

                    <div className="clearfix">
                        {listing}
                    </div>
                </div>
            </div>
        );
    },

    renderAssigned: function () {
        var self = this;
        var assigned = this.getAssignedTechnicians().map(function (tech) {
            return _(self.props.data).findWhere({ techName: tech });
        });

        return assigned.map(function (technician, index) {
            return (
                <div key={'assigned-technician-' + index}
                    className="panel panel-default technician"
                >

                    <div className="panel-heading">
                        {technician.techName}
                    </div>

                    <div className="panel-body text-right">
                        <div className="btn-group" role="group">
                            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_TECHNICIANS.READ}>
                                <button type="button" className="btn btn-default"
                                    onClick={this.showSchedule.bind(null,
                                        technician.techID)}
                                >
                                    <i className="fa fa-print"/> View Schedule
                                </button>
                            </RestrictedComponent>
                            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_TECHNICIANS.UPDATE}>
                                <button type="button" className="btn btn-default"
                                    onClick={this.remove.bind(null, index)}>
                                    <i className="fa fa-minus"/> Remove
                                </button>
                            </RestrictedComponent>
                        </div>
                    </div>

                </div>
            );
        }, this);
    }
});

export default EventTechnicians;
